import { combineEpics } from 'redux-observable';
import fetchProjectAccessTypesEpic from './access-types/fetch-project-access-types-epic';
import type { Action } from './access-types/project-access-action-creators';
import projectAccessValueEpic from './access-value/project-access-value-epic';
import type { State } from './project-access-types';

export default combineEpics<Action, State>(fetchProjectAccessTypesEpic, projectAccessValueEpic);
